import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "inactive",
  "use": "inactive-usage",
  "viewBox": "0 0 18.33 18.33",
  "content": "<symbol viewBox=\"0 0 18.33 18.33\" id=\"inactive\">\r\n    <title>INACTIVE</title>\r\n    <path d=\"M9.17,0a9.17,9.17,0,1,0,9.17,9.17A9.17,9.17,0,0,0,9.17,0Zm0,2a7.12,7.12,0,0,1,4.3,1.45l-10,10A7.15,7.15,0,0,1,9.17,2Zm0,14.33a7.12,7.12,0,0,1-4.3-1.45l10-10A7.15,7.15,0,0,1,9.17,16.33Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol